export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Поля формы №"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отсутствует обязательный идентификатор"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы успешно авторизовались, продолжите операции на банкомате"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Продолжите операции на банкомате"])}
}